export default "__VITE_ASSET__BWplAIxp__"